export default "__VITE_ASSET__GIX27go7__"